import { Outlet } from 'react-router';

import { ApplicationDialog } from '@/components/organisms/ApplicationDialog';

export const ConvertFlow: React.FC = (): React.ReactElement => {
  return (
    <ApplicationDialog>
      <Outlet />
    </ApplicationDialog>
  );
};
